import React from "react";
import { TitleCard, Typography } from "@platform/style";
import { WorkItem } from "../../models/WorkItem";
import RXJS from "rxjs";
import { getWorkItem } from "../../utils/storage";
import { subscribeToContextChange } from "@platform/core";
import { RenderDetails } from "./RenderDetails";

let workItemSubscription: RXJS.Subscription;

export const MyWorkItemDetails = () => {
  const [workItem, setWorkItem] = React.useState<WorkItem | undefined>(getWorkItem());
  const [loanNumber, setLoanNumber] = React.useState<string>("");
  const [_portfolioId, setPortfolioId] = React.useState<string>("");

  React.useEffect(() => {
    workItemSubscription = subscribeToContextChange("workItem", {
      onSet: () => {
        setWorkItem(getWorkItem());
      },
      onUnset: () => {
        setWorkItem(getWorkItem());
      },
    });

    return () => {
      workItemSubscription.unsubscribe();
    };
  }, []);

  React.useEffect(() => {
    window.addEventListener("updateWorkItem", statusUpdate);
    return () => {
      window.removeEventListener("updateWorkItem", statusUpdate);
    };
  }, []);

  function statusUpdate() {
    setWorkItem(getWorkItem());
  }

  React.useEffect(() => {
    if (workItem) {
      if ("Associations" in workItem) {
        const associationObject = workItem.Associations[0];
        //TODO: Do we need to check if context of wi is "Loan" ? What if context is not "Loan" ?
        const associatedContext = JSON.parse(associationObject.Key);
        setPortfolioId(associatedContext.portfolioIdentifier.toString());
        setLoanNumber(associatedContext.loanIdentifier.toString());
      }
    }
  }, [workItem]);

  return (
    <>
      {workItem && (
        <TitleCard
          title={
            <>
              Work Item:{" "}
              <Typography component="span" variant={"h5"} id={"wiTitle"}>
                {workItem.Title}
              </Typography>
            </>
          }
          id={"work-item-detail"}
        >
          <RenderDetails workItem={workItem} loanNumber={loanNumber} isInactiveWITab={false} />
        </TitleCard>
      )}
    </>
  );
};
